import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            paddingBottom: theme.spacing(4),
            display: 'inline-flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexGrow: 1,
        },
        alert: {
            margin: theme.spacing(0, 0, 2),
        },
        text: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        container: {
            marginLeft: 0,
            padding: 0,
        },
        divider: {
            margin: theme.spacing(8, 0, 3),
        },
        chip: {
            margin: theme.spacing(0.5),
        },
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            position: 'relative',
            minHeight: 200,
        },
        grid: {
            '& .MuiDataGrid-overlay': {
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 1000,
            },
        },
        tableContainer: {
            flexGrow: 1,
            minHeight: 400,
        },
        address: {
            whiteSpace: 'pre',
            fontSize: '0.7rem',
        },
        delete: {
            color: theme.palette.error.main,
        },
        restaurantOwner: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        },
        header: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
        },
        actions: {
            'flexWrap': 'wrap',
            '& button, & a': {
                'margin': theme.spacing(0, 1),
                '&:first-child': {
                    marginLeft: 0,
                },
                '&:last-child': {
                    marginRight: 0,
                },
            },
            '& > div': {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                height: '100%',
                alignSelf: 'stretch',
            },
        },
        confirmed: {
            backgroundColor: theme.palette.success.light,
            color: theme.palette.success.contrastText,
        },
        new: {
            // backgroundColor: theme.palette.warning.light,
            // color: theme.palette.warning.contrastText,
        },
        rejected: {
            'backgroundColor': theme.palette.error.light,
            'color': theme.palette.error.contrastText,
            '&:hover': {
                color: theme.palette.text.primary,
            },
        },
        iconButton: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(0.5),
            minWidth: 'auto',
            minHeight: 'auto',
            marginRight: theme.spacing(),
        },
        paper: {
            width: '100%',
        },
        editButton: {
            backgroundColor: theme.palette.background.paper,
        },

        calendarRoot: {
            width: '100%',
        },
        calendarNav: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: theme.spacing(1, 1, 2),
            gap: theme.spacing(1),
        },
        calendarNavButton: {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
        },
        calendarNavRange: {
            flexGrow: 1,
            textAlign: 'center',
            fontWeight: 600,
            fontSize: '0.95rem',
            [theme.breakpoints.down('xs')]: {
                fontSize: '0.8rem',
            },
        },
        calendarNavTodayButton: {
            whiteSpace: 'nowrap',
        },
        calendarHeaderGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
            marginBottom: theme.spacing(1),
            [theme.breakpoints.down('xs')]: {
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            },
        },
        calendarHeaderCell: {
            borderBottom: `2px solid ${theme.palette.grey.A200}`,
        },
        calendarHeaderCellContent: {
            padding: theme.spacing(0, 1),
            margin: theme.spacing(1),
        },
        calendarHeaderDow: {
            fontWeight: 600,
            lineHeight: 1.2,
        },
        calendarHeaderDate: {
            opacity: 0.85,
            fontSize: '0.9rem',
            marginTop: theme.spacing(0.25),
        },
        calendarBodyGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
            [theme.breakpoints.down('xs')]: {
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            },
        },
        calendarMonthColor: {
            minHeight: 14,
            display: 'flex',
            alignItems: 'center',
        },
        calendarMonthBar: {
            position: 'relative',
            width: '100%',
            height: 10,
        },
        calendarMonthBarStart: {
            'borderTopLeftRadius': 0,
            'borderBottomLeftRadius': 0,
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                borderTop: '5px solid transparent',
                borderBottom: '5px solid transparent',
                borderLeft: '10px solid currentColor',
                color: theme.palette.common.white,
            },
        },
        calendarMonthBarEnd: {
            'borderTopRightRadius': 0,
            'borderBottomRightRadius': 0,
            '&::after': {
                content: '""',
                position: 'absolute',
                right: 0,
                top: 0,
                width: 0,
                height: 0,
                borderTop: '5px solid currentColor',
                borderBottom: '5px solid currentColor',
                borderLeft: '10px solid transparent',
                color: theme.palette.common.white,
            },
        },
        calendarMonthBarStartOfLine: {
            borderTopLeftRadius: 2.5,
            borderBottomLeftRadius: 2.5,
        },
        calendarMonthBarEndOfLine: {
            borderTopRightRadius: 2.5,
            borderBottomRightRadius: 2.5,
        },
        calendarMonthLabel: {
            position: 'absolute',
            left: theme.spacing(2),
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: 0.3,
            color: theme.palette.common.white,
            textShadow: '0 1px 1px rgba(0,0,0,0.35)',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
        },
        calendarCell: {
            minHeight: 180,
            display: 'flex',
            flexDirection: 'column',
        },
        calendarCellMain: {
            flexGrow: 1,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5),
            margin: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
        },
        calendarCellDate: {
            opacity: 0.7,
            fontSize: '0.9rem',
            marginBottom: theme.spacing(0.5),
            [theme.breakpoints.down('xs')]: {
                fontSize: '0.7rem',
            },
        },
        calendarCellContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(0.5),
        },
        calendarSlotButtonOpen: {
            justifyContent: 'flex-start',
            textTransform: 'none',
            padding: theme.spacing(0.5, 1),
        },
        calendarSlotButtonClose: {
            justifyContent: 'flex-start',
            textTransform: 'none',
            padding: theme.spacing(0.5, 1),
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main,
        },
        calendarDialogSummary: {
            fontSize: 13,
            lineHeight: 1.4,
        },
        calendarToday: {
            borderColor: theme.palette.primary.main,
            boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
        },
        calendarClosed: {
            backgroundColor: theme.palette.action.hover,
            opacity: 0.75,
        },
        calendarSpecialClosed: {
            backgroundColor: theme.palette.error.light,
            borderColor: theme.palette.error.main,
            boxShadow: `inset 0 0 0 1px ${theme.palette.error.main}`,
            opacity: 1,
        },
        calendarSpecialLabel: {
            width: '100%',
            marginTop: theme.spacing(0.5),
            fontSize: 11,
            fontWeight: 600,
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.25, 0.75),
            display: 'inline-block',
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        calendarDialogStatus: {
            marginTop: theme.spacing(1),
            fontSize: '1rem',
        },
    }),
)
